<template>
    <ion-list>
        <ion-list-header>
            <ion-label><ion-skeleton-text animated style="width: 200px;"></ion-skeleton-text></ion-label>
        </ion-list-header>
        <ion-item class="message" v-for="n in 10" :key="`n${n}`">
            <ion-avatar slot="start" v-show="!$root.isMobileOrSmall">
                <ion-skeleton-text animated></ion-skeleton-text>
            </ion-avatar>
            <ion-label>
                <ion-item lines="none">
                    <ion-label>
                        <h2>
                            <span outline color="primary"><ion-skeleton-text animated style="height: 26px; width: 50%;"></ion-skeleton-text></span>
                        </h2>
                        <h3>
                            <ion-skeleton-text animated style="height: 22px; width: 70%;"></ion-skeleton-text>
                        </h3>
                    </ion-label>
                    <label slot="end">
                        <ion-skeleton-text animated style="height: 20px; width: 40px;"></ion-skeleton-text>
                    </label>
                </ion-item>
            </ion-label>
        </ion-item>
    </ion-list>
</template>

<script>
    export default {
        name: "MessageListSkeleton",
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .message {
        padding: 8px 0;
    }
</style>
